import React, { useEffect, useState } from 'react';
import immagineA from "./immagini/a.png";
import immagineI from "./immagini/i.png";
import immagineG from "./immagini/g.png";
import immagineSopra from "./immagini/sopra.png";
import immagineSotto from "./immagini/sotto.png";
import scritteDestra from "./immagini/scritteDestra.png";
import frecciaGiu from "./immagini/down2.png";
import gsLogo from "./immagini/gslogo.png";

import './App.css';
import 'animate.css'

const percorsoUltimaVersione = "https://aigsito.massbroken.it/versione.json";
const versione = 4 // se non coincide con quella in percorsoUltimaVersione, allora il sito ricarica

function App() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  const PAGINA_HOME=1;
  const PAGINA_PRIVACY=2;
  const PAGINA_CONTATTI=3;

  // parte da -3 per metterci 2 secondi prima di far partire la frase 1, dato che si sta componendo il logo
  const [indiceUltimaFraseVisibile, setIndiceUltimaFraseVisibile] = useState(-3);
  const [numeroFraseDettaglio, setNumeroFraseDettaglio] = useState(0);
  const numeroFrasi = 4;
  const [pagina, setPagina] = useState(PAGINA_HOME);

  function cliccataFrase(n) {
    if (numeroFraseDettaglio==n) setNumeroFraseDettaglio(0); else setNumeroFraseDettaglio(n);
  }

  const checkVersion = async () => {
    try {
      const response = await fetch(percorsoUltimaVersione+"?"+Math.floor(Math.random() * 1000));
      const { ultimaVersione } = await response.json();
  
      if (versione < ultimaVersione) {
        window.location.reload(true);
      }
    } catch (error) {
      console.error('Errore nel recupero della versione:', error);
    }
  };

  useEffect(() => {
    checkVersion();

    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    // listener per l'evento di ridimensionamento della finestra
    window.addEventListener('resize', handleResize);

    // eliminazione listener quando il componente viene smontato
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  },[]);

  useEffect(() => {
    
    const timerId = setTimeout(() => {
      if (indiceUltimaFraseVisibile >= numeroFrasi+1) return; // +1 per il fondo pagina
      setIndiceUltimaFraseVisibile(indiceUltimaFraseVisibile+1);
    }, 500); // millisecondi

    // Pulisci il timeout quando il componente si smonta
    return () => clearTimeout(timerId);
  }, [indiceUltimaFraseVisibile]);

  return (
    <div class="contenitore-intera-pagina">
      
      <div class="contenitore-superiore">
        <div class="animate__animated animate__fadeIn" style={{marginTop:20}}>
          <img style={{height: 204, width: 191}} src={immagineI} alt="AIG"/>
        </div>
        <div class="animate__animated animate__slideInDown animate__slow" style={{marginTop:-207}}>
          <img style={{height: 204, width: 191}} src={immagineSopra} alt="AIG"/>
        </div>
        <div class="animate__animated animate__slideInUp animate__slow" style={{marginTop:-207}}>
          <img style={{height: 204, width: 191}} src={immagineSotto} alt="AIG"/>
        </div>
        <div class="animate__animated animate__slideInLeft animate__slow" style={{marginTop:-207}}>
          <img style={{height: 204, width: 191}} src={immagineA} alt="AIG"/>
        </div>
        <div class="animate__animated animate__slideInRight animate__slow" style={{marginTop:-207}}>
          <img style={{height: 204, width: 191}} src={immagineG} alt="AIG"/>
        </div>
        {indiceUltimaFraseVisibile>=1 && (windowSize.width>700 ?
          <div style={{marginTop:-182, marginLeft: 400, marginBottom:40}}>
            <img src={scritteDestra} alt="AIG"/>
          </div>
          :
          <div style={{color:"#909090", fontWeight:"bold"}}>
            Azienda Informatica Genova
          </div>
        )}
      </div>

      {pagina === PAGINA_HOME &&
        <div class='contenitore-centrale'>
          {indiceUltimaFraseVisibile>=1 && 
            <div class="elemento_da_destra frase frase-cliccabile frase1" style={{display:'flex'}} onClick={()=>cliccataFrase(1)}>
              <div style={{flex:1}}>Applicazione "Gestione Sportiva" per Società Sportive</div>
              {numeroFraseDettaglio!==1 && <img style={{height:21, paddingRight:5}} src={frecciaGiu}/>}
            </div>
          }
          {numeroFraseDettaglio===1 &&
            <div class='dettaglio frase1' style={{display:'flex', flexDirection:'row'}}>
              <img style={{height: 100}} src={gsLogo} alt="Gestione Sportiva"/>
              <div style={{flex:1}}>
              Applicazione completa WEB, con APP per Android e iOS, per le società sportive: gestione di sessioni di allenamento, gare ed eventi, con convocazione atleti e chat con stanza dedicata ad ogni evento, gestione presenze e risultati, prenotazione corsi e attrezzature, schede allenamento, gestione economica, gestione abbonamenti e scadenze,... <a href='https://emasito.massbroken.it'>Scopri di più</a>
              </div>
            </div>
          }

          {indiceUltimaFraseVisibile>=2 && 
            <div class="elemento_da_destra frase frase-cliccabile frase2" style={{display:'flex'}} onClick={()=>cliccataFrase(2)}>
              <div style={{flex:1}}>Applicazioni Web personalizzate per Piccole e Grandi Aziende</div>
              {numeroFraseDettaglio!==2 && <img style={{height:21, paddingRight:5}} src={frecciaGiu}/>}
            </div>
          }
          {numeroFraseDettaglio===2 &&
            <div class='dettaglio frase2'>
              Realizzazione di applicazioni web che vanno dal semplice sito web vetrina, all'e-commerce, alle applicazioni dedicate per specifiche attività come turni di lavoro, prenotazione prestazioni o attrezzature, abbonamenti,...
            </div>
          }

          {indiceUltimaFraseVisibile>=3 && 
            <div class="elemento_da_destra frase frase-cliccabile frase3" style={{display:'flex'}} onClick={()=>cliccataFrase(3)}>
              <div style={{flex:1}}>APP per Android e iOS</div>
              {numeroFraseDettaglio!==3 && <img style={{height:21, paddingRight:5}} src={frecciaGiu}/>}
            </div>}
          {numeroFraseDettaglio===3 &&
            <div class='dettaglio frase3'>
              Realizzazione di APP autonome o connesse ad un'applicazione web, per esempio per prenotazioni, controllo accessi, gestione magazzino, abbonamenti,...
            </div>
          }

          {indiceUltimaFraseVisibile>=4 && 
            <div class="elemento_da_destra frase frase-cliccabile frase4" style={{display:'flex'}} onClick={()=>cliccataFrase(4)}>
              <div style={{flex:1}}>Corsi di formazione personalizzati</div>
              {numeroFraseDettaglio!==4 && <img style={{height:21, paddingRight:5}} src={frecciaGiu}/>}
            </div>
          }
          {numeroFraseDettaglio===4 &&
            <div class='dettaglio frase4'>Corsi di formazione professionali di sviluppo software e gestione sistemistica</div>
          }
          </div>
        }

        {pagina === PAGINA_HOME &&
          (indiceUltimaFraseVisibile>=5 && windowSize.height<520 &&
            <div class='contenitore-inferiore'>
              <span class='voce-menu-inferiore' onClick={() => setPagina(PAGINA_CONTATTI)}>Contatti</span>
              <span class='voce-menu-inferiore' onClick={() => setPagina(PAGINA_PRIVACY)}>Privacy</span>            
              <div style={{fontSize:9, marginTop:20}}>(c) 2024, Azienda Informatica Genova Srl, P.IVA 02927720991</div>
            </div> 
          )
        
      }

      {pagina === PAGINA_CONTATTI &&
        <div class='contenitore-centrale'>
          <div class="elemento_da_destra frase frase1">
            Contatti
          </div>
          <div class='dettaglio frase1' style={{textAlign:'center'}}>
            <b>Email:</b><br/>info@aigenova.it<br/><br/>
            <b>PEC:</b><br/>aigenova@pec.poste.it<br/><br/>
            <b>Indirizzo:</b><br/>via Assarotti 10/2 16122 Genova Italy
            <div class="bottone1" onClick={() => setPagina(PAGINA_HOME)}>Torna alla pagina principale</div>
          </div>
        </div>
      }

      {pagina === PAGINA_PRIVACY &&
        <div class='contenitore-centrale'>
        <div class="elemento_da_destra frase frase1">
          Privacy
        </div>
        <div class='dettaglio frase1' style={{textAlign:'center'}}>
          Questo sito, aigenova.it, non utilizza cookies di tracciamento<br/>e non chiede alcun dato personale ai visitatori.
          <div class="bottone1" onClick={() => setPagina(PAGINA_HOME)}>Torna alla pagina principale</div>
        </div>
      </div>
      }

      {indiceUltimaFraseVisibile>=5 && windowSize.height>=520 &&
        <div class='contenitore-inferiore contenitore-inferiore-fisso-in-fondo'>
          <span class='voce-menu-inferiore' onClick={() => setPagina(PAGINA_CONTATTI)}>Contatti</span>
          <span class='voce-menu-inferiore' onClick={() => setPagina(PAGINA_PRIVACY)}>Privacy</span>            
          <div style={{fontSize:9, marginTop:20}}>(c) 2024, Azienda Informatica Genova Srl, P.IVA 02927720991</div>
        </div>          
      }      

    </div>
  );
}

export default App;
